export default "__VITE_ASSET__CbetYCjc__"